<template>
    <div class="home">
        <Head :logoCode="2" :changeLogo="changeLogo" />
        <div class="swiper-container" id="swiper-container1">
            <div class="swiper-wrapper home-page-swiper">
                <div class="swiper-slide">
                    <div class="swiper-container swiper-banner" id="swiper-container3">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" data-swiper-autoplay="31000">
                                <video-player 
                                    class="video-player-box"
                                    ref="videoPlayer"
                                    :options="playerOptions"
                                    :playsinline="true"
                                >
                                </video-player>
                                <div 
                                    class="video-bg"
                                >
                                    <div class="page1-b1-box">
                                        <!-- <div :class="[page_num == 0? 'animation0' : '']"></div> -->
                                        <h4>{{ $t('p1.t1') }}</h4>
                                        <h3>{{ $t('p1.t2') }}</h3>
                                        <p>{{ $t('p1.t3') }}</p>
                                        <p>{{ $t('p1.t4') }}</p>
                                    </div>
                                    <router-link to="/aboutus" tag="div" class="video-play">
                                        <span class="line line1"></span>
                                        <span class="line line2"></span>
                                        <span class="line line3"></span>
                                        <span class="line line4"></span>
                                        <span>{{ $t('learnmore') }}</span>
                                        <!-- <img src="../../assets/icon/right.png" alt=""> -->
                                    </router-link>
                                </div>
                            </div>
                            <div class="swiper-slide" data-swiper-autoplay="10000">
                                <div
                                    class="page1-b2-box"
                                >   
                                    <div class="left-box">
                                        <img v-if="$i18n.locale == 'fr'" src="../../assets/home/covid19_title_logo_fr@2x.png" alt="" style="width: 300px">
                                        <img v-else-if="$i18n.locale == 'ru'" src="../../assets/home/covid19_title_logo_ru@2x.png" alt="" style="width: 300px">
                                        <img v-else src="../../assets/home/covid19_title_logo@2x.png" alt="" style="width: 300px">
                                        <h3>{{ $t('p1.t6') }}</h3>
                                        <p>{{ $t('p1.t7') }} <span>{{ $t('p1.t8') }}</span> </p>
                                        <p>{{ $t('p1.t9') }}</p>
                                    </div>
                                    <div class="right-btn">
                                        <router-link to="/covid"> {{ $t('p1.t10') }}</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg_box">
                            <div class="first" :class="{bg_default: showBottom}" v-if="firstActive === 0"></div>
                            <div class="second" :class="{bg_default: showBottom}" v-if="firstActive === 1"></div>
                        </div>
                        <div class="swiper-scrollbar"></div>
                        <div class="swiper-loading" ></div>
                    </div>
                </div>
             </div>
        </div>
                <!-- <div class="swiper-slide" style="overflow: hidden;"> -->
        <div 
            class="page2-b1-box node-anchor"
        >   
            <div class="solution-bg"></div>
            <div class="content">
                <div class="head-box">
                  <h3>
                      <!-- <router-link to="/project"> -->
                      <span>{{ $t('p2.t1') }}</span>
                      <!-- </router-link> -->
                  </h3>
                  <!-- <p>{{ $t('p2.t2') }}</p> -->
                </div>
                <div class="body-box">
                    <div class="box-up tranform">
                        <div class="box-img img1">
                            <router-link to="/project#tab1"><img src="../../assets/home/pic1@2x.png" alt=""></router-link>
                        </div>
                        <router-link to="/project#tab1" tag="div" class="box-desc bg1">
                            <div class="box-right">
                              <h4>{{ $t('p2.box.desc1.t') }}</h4>
                              <p>{{ $t('p2.box.desc1.d') }}</p>
                            </div>
                            <div class="read-more">{{ $t('learnmore') }}<img src="../../assets/home/icon2@2x.png" alt=""></div>
                        </router-link>
                    </div>
                    <div class="box-down margin40">
                        <router-link tag="div" to="/project#tab2" class="box-desc bg2">
                            <div class="box-left">
                              <h4>{{ $t('p2.box.desc2.t') }}</h4>
                              <p>{{ $t('p2.box.desc2.d') }}</p>
                            </div>
                            <div class="read-more">{{ $t('learnmore') }}<img src="../../assets/home/icon2@2x.png" alt=""></div>
                        </router-link>
                        <div class="box-img-other img2">
                            <router-link to="/project#tab2"><img src="../../assets/home/pic2@2x.png" alt=""></router-link>
                        </div>
                    </div>
                    <div class="box-up tranform">
                        <div class="box-img img3">
                            <router-link to="/project#tab3"><img src="../../assets/home/pic3@2x.png" alt=""></router-link>
                        </div>
                        <router-link tag="div" to="/project#tab3" class="box-desc bg3">
                            <div class="box-right">
                              <h4>{{ $t('p2.box.desc3.t') }}</h4>
                              <p>{{ $t('p2.box.desc3.d') }} <br > {{ $t('p2.box.desc3.d1') }}</p>
                            </div>
                            <div class="read-more">{{ $t('learnmore') }}<img src="../../assets/home/icon2@2x.png" alt=""></div>
                        </router-link>
                    </div>
                    <div class="box-down">
                        <div class="box-img img4">
                            <router-link to="/project#tab4"><img src="../../assets/home/pic4@2x.png" alt=""></router-link>
                        </div>
                        <router-link tag="div" to="/project#tab4" class="box-desc bg4">
                            <div class="box-left">
                              <h4>{{ $t('p2.box.desc4.t') }}</h4>
                              <p>{{ $t('p2.box.desc4.d') }}</p>
                            </div>
                            <div class="read-more">{{ $t('learnmore') }}<img src="../../assets/home/icon2@2x.png" alt=""></div>
                        </router-link>
                    </div>
                </div>
                <!-- <div 
                    class="body-foot"
                >
                    <img src="../../assets/icon/down.png" alt="">
                    <div :class="animation1"></div>
                </div> -->
                <div class="page-go-bottom"><router-link to="/project" class="go-inner"><span>{{ $t('tips.cando') }}</span><img src="../../assets/home/iconbg2@2x.png" alt=""></router-link></div>
            </div>
        </div>
                <!-- </div> -->
                <!-- <div class="swiper-slide" style="overflow: hidden;"> -->
            <div class="page3-b1-box">
                <div class="box-body">
                    <div class="box-row" ref="aniNews">
                        <div class="title">
                            <h3>
                                <span>{{ $t('p3.t1') }}</span>
                            </h3>
                            <p>{{ $t('p3.t2') }}</p>
                        </div>
                        <div class="box-card" v-for="(item, index) in newsTop" :key="index" @click="goNewsDetail(item)">
                           <div class="img-outer" :style="{backgroundImage: `url(${$appUrl.imgHost+item.cover_path})`}">
                               <div class="front">
                                   <div class="date">{{item.create_time | timeFomatter}}</div>
                                   <span>{{item.title}}</span>
                                </div>
                           </div>
                            <!-- <img :src="item.cover_path" alt=""> -->
                            <div class="mask-card">
                                <div class="date">{{item.create_time | timeFomatter}}</div>
                                <h5>{{item.title}}</h5>
                                <p>{{item.description}}</p>
                                <div class="more">
                                    <span>{{ $t('p3.t3') }}</span>
                                    <img src="../../assets/icon/home_more1.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box-row">
                        <div class="box-card" v-for="(item, index) in newsBottom" :key="index" @click="goNewsDetail(item)">
                             <div class="img-outer" :style="{backgroundImage: `url(${$appUrl.imgHost+item.cover_path})`}">
                                <div class="front">
                                   <div class="date">{{item.create_time | timeFomatter}}</div>
                                   <span>{{item.title}}</span>
                                </div>
                             </div>
                            <div class="mask-card">
                                <div class="date">{{item.create_time | timeFomatter}}</div>
                                <h5>{{item.title}}</h5>
                                <p>{{item.description}}</p>
                                <div class="more">
                                    <span>{{ $t('p3.t3') }}</span>
                                    <img src="../../assets/icon/home_more1.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="page-go-bottom"><router-link to="/news" class="go-inner"><span>{{ $t('tips.morenews') }}&nbsp;</span><img src="../../assets/home/icon@2x.png" alt=""></router-link></div>
                </div>
                <!-- <div class="box-foot">
                    <img src="../../assets/icon/h_p3_down.png" alt="">
                </div> -->
            </div>
                <!-- </div> -->
                <!-- <div class="swiper-slide"> -->
                    <div class="swiper-footer">
                        <div class="swiper-container swiper-no-swiping" id="swiper-container2">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide slide-box-auto">
                                    <div class="page4-b1-box">
                                        <div class="page4-b2-box">
                                            <div class="box-body" ref="aniAbout" >
                                                <!-- <div v-show="aniAbout" class="animation3"></div> -->
                                                <div class="left">
                                                    <div class="p4-t">
                                                        {{ $t('p4.t1') }}
                                                    </div>
                                                </div>
                                                <div class="center">
                                                    <router-link to="/aboutus?tabNum=1" class="card-item1">
                                                        <div class="content">
                                                            <div class="icon-img">
                                                                <img src="../../assets/home/home_p4_icon1.png" alt="">
                                                                <div>{{ $t('p4.card.c1.t1') }}</div>
                                                            </div>
                                                            <p>{{ $t('p4.card.c1.d1') }}</p>
                                                        </div>
                                                    </router-link>
                                                    <router-link to="/aboutus?tabNum=1#shanghai" class="card-item3">
                                                        <div class="content">
                                                            <div class="icon-img">
                                                                <img src="../../assets/home/home_p4_icon3.png" alt="">
                                                                <div>{{ $t('p4.card.c3.t1') }}</div>
                                                            </div>
                                                            <p>{{ $t('p4.card.c3.d1') }}</p>
                                                        </div>
                                                    </router-link>
                                                </div>
                                                <div class="right">
                                                    <router-link to="/aboutus?tabNum=1#seameo" class="card-item2">
                                                        <div class="content">
                                                            <div class="icon-img">
                                                                <img src="../../assets/home/home_p4_icon2.png" alt="">
                                                                <div>{{ $t('p4.card.c2.t1') }}</div>
                                                            </div>
                                                            <p>{{ $t('p4.card.c2.d1') }}</p>
                                                        </div>
                                                    </router-link>
                                                    <router-link to="/aboutus?tabNum=1#moe" class="card-item4">
                                                        <div class="content">
                                                            <div class="icon-img">
                                                                <img src="../../assets/home/home_p4_icon4.png" alt="">
                                                                <div>{{ $t('p4.card.c4.t1') }}</div>
                                                            </div>
                                                            <p>{{ $t('p4.card.c4.d1') }}</p>
                                                        </div>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="box-foot">
                                            <router-link to="/aboutus?tabNum=1">
                                            <img src="../../assets/icon/down.png" alt="">
                                            </router-link>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <Footer />
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- </div> -->
           
        <div class="back-top" ref="backTop" v-show="showTop" @click="backTop">
            <span>{{$t('top')}}</span>
        </div>
        <div id="cookie-disclosure" class="cookie-alert eu-cookie-compliance-banner" :class="{'show-notice': alertCookie}">
            <div class="eu-cookie-compliance-content">
                <div class="eu-cookie-compliance-message">
                    <div><p>{{$t('tips.cookie1')}}&nbsp;{{$t('tips.cookie2')}}&nbsp;<span class="link" @click="goPrivary"><strong>{{$t('tips.cookie3')}}.</strong></span></p></div>
                </div>
                <div class="eu-cookie-compliance-message">
                    <span id="cookie-compliance-control" class="eu-cookie-compliance-default-button" @click="understand">{{$t('tips.cookie4')}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css'
import Head from '../../components/head'
import Footer from '../../components/footer'
import api from '../../api/news';

export default {
    components: {
        Head,
        Footer,
        // Popup,
    },
    data() {
        return {
            page_num: 0,
            changeLogo: true,
            type: true,
            scrollType: false,
            playerOptions: {
                muted:true,
                autoplay: true,
                loop: true,
                controls: false,
                preload: 'auto',
                sources: [{
                    type: "video/mp4",
                    src: 'https://welms.oss-cn-beijing.aliyuncs.com/overseas/10.27%20%E5%AE%98%E7%BD%91%E8%A7%86%E9%A2%91.mp4'
                }]
            },
            alertCookie: false,
            newsTop: [],
            newsBottom: [],
            showBottom: true,
            aniAbout: false,
            aniNews: false,
            firstActive: 0,
            showTop : false,
            scrollTop: 0,
        };
    },
    created() {
        const checkCookie = localStorage.getItem('checkCookie');
        if (checkCookie === '1') {
            this.alertCookie = false;
        } else {
            this.alertCookie = true;
        }
        this.getNewsList();
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player
        }
    },
    mounted(){        
        const _this = this;
        // this.$refs.videoPlayer.player.play()
        this.swiper1 = new Swiper('#swiper-container1', {
                direction: "vertical",
                autoHeight: true,
                speed: 800,
                noSwiping: true,
                mousewheel: {
                    releaseOnEdges: true,
                    eventsTarged: ".swiper-wrapper.home-page-swiper"
                },
                simulateTouch: false,
                forceToAxis: true,
                preloadImages: false,
                preventIntercationOnTransition: true,
                on: {
                    slideChangeTransitionEnd() {
                        _this.page_num = this.activeIndex;
                        if (this.activeIndex > 0) {
                            _this.changeLogo = false;
                        } else {
                            _this.changeLogo = true;
                        }
                        if (this.activeIndex == 3) {
                            this.mousewheel.disable();
                        }
                    }
                }
        });

        this.swiper2 = new Swiper('#swiper-container2', {
                direction: "vertical",
                slidesPerView: "auto",
                mousewheel: true,
                freeMode: true,
                freeModeMomentumVelocityRatio: 1,
                nested: true,
                freeModeMomentumBounce: false,
                on: {
                    init: function() {
                        window.addEventListener("wheel", function(event) {
                            let e= event || window.event;
                            if (_this.scrollType) {
                                if(e.wheelDelta){ 
                                    if(e.wheelDelta>0){ 
                                        _this.scrollType = false;
                                        _this.swiper1.mousewheel.enable();
                                    }
                                }else if(e.detail){
                                    if(e.detail<0){
                                        _this.scrollType = false;
                                        _this.swiper1.mousewheel.enable();
                                    }
                                }
                            }
                            
                        }, false)
                    },
                    progress(progress) {
                        if (progress == 0) {
                            _this.scrollType = true;
                        } else {
                            _this.scrollType = false;
                        }
                    }
                }
        });

        this.swiper3 = new Swiper('#swiper-container3', {
            autoplay: {
                disableOnInteraction: false,
                delay: 10000,
            },
            pagination: {
                el: '.swiper-scrollbar',
                draggable: true,
                clickable :true,
            },
            on: {
                slideChange: function () {
                    _this.firstActive = this.activeIndex;
                    _this.showBottom = false;
                    setTimeout(function() {
                        _this.showBottom = true;
                    }, 10)
                },
            }
        });
        window.addEventListener('scroll', this.handleScroll);
    },
    
    methods: {
        fullScreen() {
            this.player.requestFullscreen();
            this.player.controls(true);
        },
        language() {
            this.type = !this.type;
            this.$i18n.locale = this.type ? 'zh-cn' : 'en-us'
        },
        goPrivary() {
            this.$router.push({
                path: '/privacy',
            })
        },
        understand() {
            localStorage.setItem('checkCookie', '1');
            this.alertCookie = false;
        },
        getNewsList() {
            api.newsList({pageNum:1, position: 4}, this.$i18n.locale).then(res => {
                if (res.list && res.list.length >= 5) {
                    this.newsTop = res.list.slice(0, 2);
                    this.newsBottom = res.list.slice(2, 5)
                } else if (res.list && res.list.length > 2 ){
                    this.newsTop = res.list.slice(0, 2);
                } else if(res.list ) {
                    this.newsTop = res.list;
                }
            })
        },
        goNewsDetail(item) {
            this.$router.push({
                path: '/newsinfo',
                query: {
                    id: item.id
                }
            })
        },
        backTop () {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        handleScroll() {
            let _this = this;
            let refArray = [
                {ref: 'aniAbout', show: 'aniAbout'},
                {ref: 'aniNews', show: 'aniNews'},
            ];
            refArray.forEach((r) => {
                _this.gdjz(r.ref, 80, () => {
                _this[r.show] = true
                })
            })
            let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            _this.scrollTop = scrollTop;
            let clientHeight = window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight;
            if (scrollTop > clientHeight) {
                this.showTop = true;
            } else {
                this.showTop = false;
            }
        },
        gdjz (div, offset, callback) {
            let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
            if(dom){
                var a,b,c,d;
                d = this.getElementTop(dom); // 元素距离相对父级的高度，这里父级指的是body
                a = eval(d + offset)
                b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
                c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
                if( b + c > a ) {
                    callback && callback()
                }
            }
        },
        getElementTop(element){
            let actualTop = element.offsetTop;
            let current = element.offsetParent;
            while (current !== null){
                actualTop += current.offsetTop;
                current = current.offsetParent;
            }
            return actualTop;
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll)
        },
    }
}
</script>

<style lang="less">
.home {
    .back-top {
        position: fixed;
        right: 0;
        width: 80px;
        height: 64px;
        bottom: 143px;
        color: #fff;
        font-size: 16px;
        box-shadow: 0px 4px 10px 0px rgba(0,150,223,0.2);
        border-radius: 4px;
        z-index: 1;
        box-sizing: border-box;
        padding-top: 33px;
        background: #0096DF url(../../assets/icon/icon-backtop@2x.png) center 9px;
        background-size: 20px 20px;
        background-repeat: no-repeat;
        text-align: center;
        cursor: pointer;
    }
    height: 100%;
    .page-go-bottom {
        position: relative;
        font-size: 22px;
        height: 26px;
        font-family: HelveticaNeue-Medium, HelveticaNeue, Arial, sans-serif ;
        font-weight: 500;
        color: #CAA765;
        margin-top: 100px;
        text-align: center;
        transition: all 0.1s linear;
        .go-inner {
            align-items: center;
        }
        a {
            color: #CAA765;
            text-decoration: none;
            font-size: 22px;
            margin: 0 auto;
        }
        img {
            display: inline-block; 
            width: 23px;
            height: 20px;
            line-height: 26px;
            position: relative;
            top: 2px;
        }
        &:hover {
            transform: translateY(-2px);
        }
    }
}
.cookie-alert {
    background-color:#4776be;
    color:#fff;
    font-size:.77778rem;
    position:fixed;
    bottom:0;
    left:0;
    right:0;
    a {
        color: #fff;
    }
}
.eu-cookie-compliance-banner {
        display:none;
        z-index:1000
}
.eu-cookie-compliance-banner.show-notice {
    display:block
}
.eu-cookie-compliance-banner .eu-cookie-compliance-content {
    text-align:center;
    max-width:44.44444rem;
    padding:1.66667rem 2.77778rem;
    margin:0 auto
}
.eu-cookie-compliance-banner .eu-cookie-compliance-content .link {
    text-decoration:underline;
    cursor: pointer;
}
.eu-cookie-compliance-banner .eu-cookie-compliance-content .link:focus, .eu-cookie-compliance-banner .eu-cookie-compliance-content .link:hover {
    text-decoration:none;
    color:#fefefe
}
.eu-cookie-compliance-banner .eu-cookie-compliance-message {
    font-size:.77778rem;
    font-weight:400;
    float:none;
    margin:0 auto;
    max-width:none
}
.eu-cookie-compliance-banner .eu-cookie-compliance-message p {
    font-weight:400
}
.eu-cookie-compliance-banner .eu-cookie-compliance-buttons {
    float:none;
    margin:0 auto;
    max-width:none
}
.eu-cookie-compliance-banner .eu-cookie-compliance-default-button {
    background:0 0;
    color:#fff;
    font-size:.77778rem;
    text-decoration:underline;
    text-shadow:none;
    box-shadow:none;
    border:none;
    font-weight:700
}
.eu-cookie-compliance-banner .eu-cookie-compliance-default-button:focus, .eu-cookie-compliance-banner .eu-cookie-compliance-default-button:hover {
    cursor:pointer;
    text-decoration:none
}

.swiper-banner {
    .swiper-slide {
        height: 100%;
    }

    .swiper-scrollbar {
        background: transparent;
        .swiper-pagination-bullet {
            width: 50px;
            height: 6px;
            background: #fff;
            border-radius: 0px;
            &:first-child {
                margin-right: 10px;
            }
        }
        cursor: pointer;
        width: 150px;
        left: 50%;
        bottom: 50px;
        transform: translateX(-50%);
        // background: rgba(255, 255, 255, 0.3);
        .swiper-scrollbar-drag {
            background: #FD8E0D;
        }
    }
    .video-player-box {
        width: 100%;
        height: 100%;
        .video-js {
            width: 100%;
            .vjs-tech {
                height: auto;
            }
        }
    }

    .video-bg {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-image: url('../../assets/home/bg1.png');
        background-size: 100% 100%;
    }

    .video-play {
        position: absolute;
        color: #fff;
        font-size: 22px;
        bottom: 20%;
        left: 50%;
        margin-left: -100px;
        cursor: pointer;
        padding: 11px 30px;
        img {
            margin-left: 12px;
            height: 22px;
            vertical-align: middle;
        }
        .line {
            position: absolute;
            background-color: #CAA765;
            display: block;
            transition: all 250ms;
        }
        .line1, .line3 {
            height: 1px;
            width: 0px;
        }
        
        .line2, .line4 {
            height: 0px;
            width: 1px;
        }
        .line1, .line2 {
            top: 0;
            right: 0;
        }
        
        .line3, .line4 {
            bottom: 0;
            left: 0;
        }
        &.reverse {
            .line1, .line3 {
                width: 100%;
            }
            .line2, .line4 {
                height: 100%;
            }
        }
        &:hover, &:active {
            background-color: transparent;
            color: #CAA765;
            
            .line1, .line3 {
                width: 100%;
            }
            
            .line2, .line4 {
                height: 100%;
            }
            
            &.reverse {
                .line1, .line3 {
                    width: 20px;
                }
                .line2, .line4 {
                    height: 20px;
                }
            }
        }
    }

    .page1-b1-box {
        color: #fff;
        position: absolute;
        top: 30%;
        width: 1100px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        .animation0 {
            z-index: 1;
            position: absolute;
            top: 0px;
            left: 0px;
            transform: translate(-50%, -50%);
            width: 136px;
            height: 136px;
            border-radius: 50%;
            background: #FD8E0D;
            animation: circle_move0 1.5s ease;
        }
        h3 {
            position: relative;
            z-index: 2;
            font-size: 68px;
            font-weight: bold;
        }
        h4 {
            position: relative;
            z-index: 2;
            font-family: HelveticaNeue-Light, HelveticaNeue, Arial;
            font-size: 40px;
            font-weight: normal;
        }

        p {
            margin-top: 24px;
            font-family: HelveticaNeue, Arial;
            font-size: 18px;
        }

        p~p{
            margin-top: 10px;
        }
    }

    .page1-b2-box {
        height: 100%;
        background-image: url('../../assets/home/bg2.png');
        background-size: 100% 100%;
        .left-box {
            position: absolute;
            top: 22%;
            left: 11%;
            color: #ffffff;
            img {
                margin-bottom: 35px;
            }
            h3 {
                font-size: 68px;
                margin-bottom: 40px;
            }
            p {
                font-size: 16px;
                margin-top: 8px;
                font-family: HelveticaNeue, Arial;
                span {
                    font-family: HelveticaNeue, Arial;
                    font-weight: bold;
                }
            }
        }
        .right-btn {
            cursor: pointer;
            font-family: HelveticaNeue, Arial;
            position: absolute;
            width: 192px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #ffffff;
            font-size: 18px;
            opacity: 0.95;
            bottom: 178px;
            right: 11%;
            &:hover {
                a {
                  transform: scale(0.9);
                }
            }
            
            a {
                color: #ffffff;
                text-decoration: none;
                width: 100%;
                height: 100%;
                background: linear-gradient(142deg, #FFA558 0%, #FD8E0D 100%);
                display: inline-block;
                transition: all 0.1s linear;
                border-radius: 25px;
                
            }
        }
    }
}

.page2-b1-box {
    background-color: #F7F7F7;
    top: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 1741px;
    background-image: url('../../assets/home/solutions_bg@2x.png');
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    .content {
        width: 1026px;
        margin: 0 auto;
        position: relative;
    }
    .head-box {
        margin-left: -6vw;
        padding-top: 9vh;
        padding-bottom: 20vh;
        color: #4650A6;
        font-size: 60px;
        h3 {
            a {
                text-decoration: none;
                color: inherit;
            }
        }
        img {
            height: 28px;
            vertical-align: middle;
            margin-left: 20px;
        }

        p {
            font-family: HelveticaNeue, Arial;
            font-size: 18px;
            margin-top: 20px;
        }
    }

    .body-box {
        position: relative;
        z-index: 3;
        display: flex;
        flex-direction: column;
        .tranform {
          margin-bottom: 40px;
          margin-left: 80px;
        }
        .margin40 {
          margin-bottom: 40px;
        }
        .box-up {
            .box-img {
              img {
                width: 484px;
                height: 276px;
              }
            }
            &:hover {
                transform: translateY(2px);
                .box-desc {
                  &::before {
                    animation: LeftToRight 0.4s ease;
                    animation-fill-mode:forwards
                  }
                }
                .box-img, .box-img-other {
                    &::after {
                        display: none;
                        content: '';
                    }
                    &::before {
                        display: none;
                        content: '';
                    }
                }
            }
        }
        .box-down {
            .box-img {
              img {
                width: 484px;
                height: 276px;
              }
            }
            &:hover {
                transform: translateY(2px);
                .box-desc {
                  &::before {
                    animation: LeftToRight 0.4s ease;
                    animation-fill-mode: forwards
                  }
                }
                .box-img, .box-img-other {
                    &::after {
                        display: none;
                        content: '';
                    }
                    &::before {
                        display: none;
                        content: '';
                    }
                }
            }
        }
        .box-up, .box-down {
            position: relative;
            flex: 1;
            transition: padding ease .3s;
            cursor: pointer;
            .box-img {
                font-size: 0;
                position: relative;
                // &::after {
                //     content: '';
                //     left: 0;
                //     top: 0;
                //     position: absolute;
                //     width: 100%;
                //     height: 100%;
                //     background-color: rgba(0, 0, 0, 0.3);
                // }
                img {
                  width: 484px;
                  height: 276px;
                }
            }
            .img1 {
              width: 484px;
              box-shadow: 0 0 35px rgba(5,14,86,0.5);
            }
            // .img1::after {
                // background-image: url('../../assets/home/p2_icon1.png');
                // background-repeat: no-repeat;
                // background-position: center;
                // background-size: 70px;
            // }
            .img2 {
              width: 484px;
              position: absolute;
              left: 525px;
              box-shadow: 0 0 35px rgba(5,14,86,0.5);
            }
            // .img2::before {
                // content: '';
                // left: 50%;
                // top: 35%;
                // transform: translateX(-50%);
                // position: absolute;
                // z-index: 5;
                // width: 70px;
                // height: 70px;
                // background-image: url('../../assets/home/p2_icon2.png');
                // background-repeat: no-repeat;
                // background-position: center;
                // background-size: 70px;
            // }
            .img3 {
              width: 484px;
              height: 276px;
              box-shadow: 0 0 35px rgba(5,14,86,0.5);
            }
            .img3::after {
                background-image: url('../../assets/home/p2_icon3.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 70px;
            }
            .img4 {
              left: 525px;
              width: 484px;
              box-shadow: 0 0 35px rgba(5,14,86,0.5);
            }
            .img4::after {
                background-image: url('../../assets/home/p2_icon4.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 70px;
            }
            .box-img-other {
                font-size: 0;
                position: relative;
                // &::after {
                //     content: '';
                //     left: 0;
                //     top: 0;
                //     position: absolute;
                //     width: 100%;
                //     height: 100%;                    
                //     background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
                //     opacity: 0.3;
                // }
                img {
                  width: 484px;
                  height: 276px;
                }
            }
            .box-desc {
                height: 237px;
                position: absolute;
                width: 1016px;
                color: #fff;
                // box-shadow: 0px 32px 30px -26px  rgba(97, 97, 97, 0.3);
                &::before {
                  position: absolute;
                  content: '';
                  width: 0%;
                  height: 237px;
                  display: inline-block;
                  background: #CAA765;
                }
                .read-more {
                  font-size: 14px;
                  position: absolute;
                  bottom: 34px;
                  right: 410px;
                  img {
                    width: 12px;
                  }                  
                }
                h4 {
                    font-size: 19px;
                }
                p {
                    margin-top: 10px;
                    font-family: HelveticaNeue, Arial;
                    font-size: 13px;
                    line-height: 1.5;
                }
            }

            .bg1 {
              top: 19px;
              left: -10px;
              z-index: -1;
              border: 1px solid #FFFFFF;
              overflow: hidden;
               height: 237px;
               width: 1016px;
              .box-right {
                width: 458px;
                position: absolute;
                right: 40px;
                padding-top: 32px;
                box-sizing: border-box;
              }
              .read-more {
                right: 410px;
              }
              &::before {
                right: 0;
              }
            }
            
            .bg2,.bg4 {
                h4 {
                  color: #fff;
                }
            }

            .bg2 {
                z-index: -1;
                bottom: 19px;
                border: 1px solid #FFFFFF;
                color: #fff;
                overflow: hidden;
                height: 237px;
                width: 1016px;
                .box-left {
                  width: 458px;
                  position: absolute;
                  left: 40px;
                  padding-top: 32px;
                  box-sizing: border-box;
                }
                .read-more {
                  left: 40px;
                }
            }

            .bg3 {
              top: 19px;
              left: -10px;
              z-index: -1;
              border: 1px solid #FFFFFF;
              overflow: hidden;
               height: 237px;
               width: 1016px;
              .box-right {
                width: 458px;
                position: absolute;
                right: 40px;
                padding-top: 32px;
                box-sizing: border-box;
              }
              .read-more {
                right: 410px;
              }
              &::before {
                right: 0;
              }
            }

            .bg4 {
              color: #fff;
              top: 19px;
              z-index: -1;
              border: 1px solid #FFFFFF;
              color: #fff;
              bottom: 10px;
              width: 1016px;
              height: 237px;
              overflow: hidden;
              .box-left {
                width: 458px;
                position: absolute;
                left: 40px;
                padding-top: 32px;
                box-sizing: border-box;
              }
              .read-more {
                left: 40px;
              }
            }
        }
    }
    .page-go-bottom {
      margin-top: 64px;
      span {
        color: #CAA765;
      }
    }
    .body-foot {
        position: absolute;
        left: 50%;
        bottom: 40px;
        transform: translateX(-50%);
        img {
            position: relative;
            z-index: 2;
            height: 14px;
        }
        .animation1 {
            z-index: 1;
            position: absolute;
            width: 400px;
            height: 400px;
            left: -182px;
            top: -30px;
            border-radius: 50%;
            background: #FD8E0D;
            animation: circle_move1 .4s ease-in;
        }
    }
}

.page3-b1-box {
    background-image: url('../../assets/home/home_news_bg.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 860px;
    .animation2 {
        position: absolute;
        transform: translate(-50%, -50%);
        width: 180px;
        height: 180px;
        border-radius: 50%;
        background: #FD8E0D;
        top: 120px;
        animation: circle_move2 1s ease-in;
    }

    .box-body {
        position: relative;
        margin: 0 auto;
        width: 1025px;
        padding-top: 130px;
        .box-row {
            position: relative;
            z-index: 3;
            display: flex;
            height: 254px;
            margin-bottom: 20px;
            .title {
                position: relative;
                flex: 1;
                color: #333;
                padding-top: 44px;
                h3 {
                    position: absolute;
                    top: 0;
                    left: -80px;
                    font-size: 60px;
                    color: #4650A6;
                    img {
                        margin-left: 20px;
                        height: 28px;
                    }
                    a {
                        text-decoration: none;
                        color: inherit;
                    }
                }

                p {
                    position: absolute;
                    top: 82px;
                    left: -80px;
                    font-family: HelveticaNeue, Arial;
                    font-size: 18px;
                    color: #4650A6;
                }
            }
            .box-card {
                width: 317px;
                position: relative;
                overflow: hidden;
                cursor: pointer;
                &:hover {
                    .mask-card {
                        top: 0;
                    }
                    .img-outer {
                        .front {
                            bottom: -100px;
                        }
                    }

                }
                .img-outer {
                    width: 317px;
                    height: 254px;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: center;
                    position: relative;
                    .front {
                        position: absolute;
                        bottom: 16px;
                        left: 20px;
                        right: 20px;
                        color: #fff;
                        transition: all .3s ease;
                        .date {
                            font-size: 12px;
                            font-family: HelveticaNeue, Arial, sans-serif;
                            color: #FFFFFF;
                            line-height: 12px;
                            margin-bottom: 6px;
                        }
                        .title {
                            font-size: 18px;
                            font-family: HelveticaNeue-Medium, HelveticaNeue, Arial, sans-serif;
                            font-weight: 500;
                            color: #FFFFFF;
                            line-height: 22px;
                        }
                    }
                }
                img {
                    width: 100%;
                    height: 100%;
                }
                .mask-card {
                    transition: all .3s ease;
                    box-sizing: border-box;
                    position: absolute;
                    top: 100%;
                    width: 100%;
                    height: 100%;
                    // background: linear-gradient(180deg, rgba(58, 87, 203, 0.85) 0%, #2C369E 100%);
                    background: url(../../assets/home/news_bg.png) no-repeat;
                    opacity: 0.98;
                    color: #fff;
                    padding: 30px 20px 25px;
                    h5 {
                        font-size: 18px;
                    }
                    .date {
                        font-size: 12px;
                        font-family: HelveticaNeue, Arial, sans-serif;
                        color: #FFFFFF;
                        line-height: 12px;
                        margin-bottom: 6px;
                    }

                    p {
                        margin-top: 10px;
                        color: rgba(255, 255, 255, 0.7);
                        font-family: HelveticaNeue, Arial, sans-serif;
                        font-size: 12px;
                        line-height: 1.5;
                    }

                    .more {
                        position: absolute;
                        right: 20px;
                        bottom: 25px;
                        line-height: 16px;
                        font-size: 14px;
                        font-family: HelveticaNeue, Arial;
                        img {
                            height: 16px;
                            width: 16px;
                            margin-left: 7px;
                            vertical-align: text-bottom;
                        }
                    }
                }
            }
            .box-card ~ .box-card {
                margin-left: 10px;
            }
        }
    }

    .box-foot {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 40px;
        img {
            height: 14px;
        }
        display: none;
    }
}

.swiper-footer {
    position: relative;
    // width: 100%;
    // height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    .slide-box-auto {
        height: 100%;
    }

    .page4-b1-box {
        height: 768px;
        background: url('../../assets/home/bg5.png');
        background-size: cover;
        .page4-b2-box {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            // background-image: url('../../assets/home/bg5_bg.png');
            background-size: 100% 100%;
            .animation3 {
                z-index: 1;
                position: absolute;
                top: 178px;
                left: 50%;
                transform: translateX(-777px);
                width: 396px;
                height: 396px;
                border-radius: 50%;
                background: #FD8E0D;
                opacity: 0.95;
                animation: circle_move3 1s ease-in;
            }
            .box-body {
                display: flex;
                color: #fff;
                width: 1026px;
                margin: 0 auto;
                padding-top: 70px;
                .left {
                    position: relative;
                    z-index: 2;
                    padding-top: 140px;
                    width: 300px;
                    font-size: 60px;
                    // margin-right: 66px;
                    line-height: 75px;
                    font-weight: bold;
                    .p4-t {
                        position: absolute;
                        top: 100px;
                        left: -80px;
                    }
                }
                .right {
                    padding-top: 36px;
                }
                .center,.right {
                    flex: 1;
                    a {
                        color: #fff;
                        text-decoration: none;
                    }
                    .icon-img {
                        img {
                            width: 100px;
                        }
                    }
                    p{
                        margin-top: 24px;
                        font-size: 12px;
                        font-family: HelveticaNeue, Arial;
                        line-height: 1.5;
                    }
                    .content{
                        display:table-cell;
                        vertical-align:middle;
                        text-align: center;
                        padding: 0 24px;
                        height: 292px;
                        transition: all .5s ease;
                        cursor: pointer;
                        &:hover {
                            transform: scale(1.1);
                        }
                        
                    }
                    .card-item1,.card-item2,.card-item3,.card-item4 {
                        display: block;
                        background-image: url('../../assets/home/p4_bg.png');
                        background-size: 100% 100%;
                        margin: 0 10px 10px 0;
                    }
                }
            }

            .box-foot {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 40px;
                img {
                    height: 14px;
                }
            }
        }

    }
}
.bg_box {
        position:absolute;
        bottom: 0px;
        z-index: 100; 
        width: 100%;
        height: 8px;
        margin: 0 auto;
        background: rgba(255, 255, 255, 0.3);
        overflow: hidden;
    }
    /* 进度条容器默认样式 */
    .bg_default {
      /* 动画时长1s */
      animation-duration: 10s;
      /*当动画完成后，保持最后一个属性值（在最后一个关键帧中定义）*/
      /* animation-fill-mode: forwards;  */
      /* 动画次数 无限次 */
      animation-iteration-count: infinite;
      /* 执行动画名称 */
      animation-name: animationa;
      /* 动画速度，线性匀速 */
      animation-timing-function: linear;
      /* 背景颜色 */
      /* background: linear-gradient(to right, #fff 0%, #fff 50%, transparent 50%, transparent 100%); */
      // background: linear-gradient(90deg, #2735AE 0%, #081795 100%);
      background: linear-gradient(90deg, #CAA765 0%, #C68916 100%);
      /* 背景大小: 这里是容器大小 */
      width: 100%;
      height: 8px;
      position: absolute;
      top: 2px;
      &.first {
           animation-duration: 31s;
      }
  }
  
  @keyframes LeftToRight {
    /* 第二页背景颜色填充 */
    0% {
      width: 0%;          
    }
    100% {
      width: 100%;
    }
  }

  @keyframes animationa {
      /* 修改用作背景的进度条容器定位 */
      0% {
          /* background-position: -410px 0; */
          left: -100%;
      }
      100% {
          /* background-position: 410px 0 */
          left: 0px;
      }
  }


@keyframes circle_move0 {
    from {
        // left: 0;
        width: 3000px;
        height: 3000px;
        opacity: 0;
    }
    to {
        width: 139px;
        height: 139px;
        // left: 50%;
        opacity: 1;
    }
}

@keyframes circle_move1 {
    from {
        top: 60px;
        opacity: 0;
    }
    to {
        top: -30px;
        opacity: 1;
    }
}

@keyframes circle_move2 {
    from {
        // left: 0;
        width: 0px;
        height: 0px;
        opacity: 0;
    }
    to {
        // left: 50%;
        width: 180px;
        height: 180px;
        opacity: 1;
    }
}

@keyframes circle_move3 {
    from {
        width: 0px;
        height: 0px;
        opacity: 0;
    }
    to {
        width: 396px;
        height: 396px;
        opacity: 1;
    }
}


.swiper-container {
    height: 100%;
    width: 100%;
}
.lang-ru {
    .swiper-footer .page4-b1-box .box-body .left {
        font-size: 50px;
        line-height: 68px;
    }
    .page2-b1-box .body-box .box-down .box-desc {
        height: 237px;
        box-sizing: border-box;
    }
    .page2-b1-box .body-box .box-up .box-desc {
        height: 237px;
        box-sizing: border-box;
    }
    .page2-b1-box .box-desc .box-down .box-desc .read-more {

    }
    .page2-b1-box .body-box .box-up .bg3 .read-more {
      right: 390px;
    }
    .page2-b1-box .body-box .box-up .bg1 .read-more {
      right: 390px;
    }
}
.lang-fr {
    .page2-b1-box .body-box .box-down .box-desc {
        height: 237px;
        box-sizing: border-box;
    }
    .page2-b1-box .body-box .box-up .box-desc {
        height: 237px;
        box-sizing: border-box;
    }
    .page2-b1-box .box-desc .box-down .box-desc .read-more {
      
    }
    .page2-b1-box .body-box .box-up .bg3 .read-more{
      right: 400px;
    }
    .page2-b1-box .body-box .box-up .bg1 .read-more{
      right: 400px;
    }
}

@media(max-width: 1400px) {
    .page2-b1-box {
        .head-box {
            margin-left: -9vw;
            padding-top: 6vh;
            padding-bottom: 20vh;
        }
    }
}
</style>